<template>
	<div class="">
		<div v-if="form" class="">
			<div class="container py-4">
				<!-- Printable Content -->
				<div class="card shadow-sm" ref="printContent">
					<div class="card-header text-white">
						<div class="d-flex align-items-center">
							<h4 class="mb-0">REPORT DETAILS</h4>
						</div>
					</div>
					<div class="card-body p-0">
						<!-- Campaign Information -->
						<legend class="px-3 pt-3 mb-0">
							<h5 class="">Campaign Information</h5>
						</legend>
						<div class="list-group list-group-flush">
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Political Party</div>
									<div class="col-md-9">{{ form.party }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Position</div>
									<div class="col-md-9">{{ form.position }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">State</div>
									<div class="col-md-9">{{ form.state }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">LGA</div>
									<div class="col-md-9">{{ form.lga || "N/A" }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Candidate Name</div>
									<div class="col-md-9">{{ form.candidate_name }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Constituency</div>
									<div class="col-md-9">{{ form.constituency || "N/A" }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Constituency Code</div>
									<div class="col-md-9">
										{{ form.constituency_code || "N/A" }}
									</div>
								</div>
							</div>
						</div>

						<!-- Donor Information -->
						<legend class="px-3 pt-3 mb-0">
							<h5 class="">Donor Information</h5>
						</legend>
						<div class="list-group list-group-flush">
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Donor Name</div>
									<div class="col-md-9">{{ form.donor_name }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Donor Address</div>
									<div class="col-md-9">{{ form.donor_address }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Donor Occupation</div>
									<div class="col-md-9">{{ form.donor_occupation }}</div>
								</div>
							</div>
						</div>

						<!-- Contribution Details -->
						<legend class="px-3 pt-3 mb-0">
							<h5 class="">Contribution Details</h5>
						</legend>
						<div class="list-group list-group-flush">
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Contribution Type</div>
									<div class="col-md-9">{{ form.contribution_type }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Description</div>
									<div class="col-md-9">
										{{ form.contribution_description }}
									</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Value</div>
									<div class="col-md-9 fw-bold">
										<span class="badge bg-primary">
											{{ form.contribution_value }}
										</span>
									</div>
								</div>
							</div>
						</div>

						<!-- Administrative Details -->
						<legend class="px-3 pt-3 mb-0">
							<h5 class="">Administrative Details</h5>
						</legend>
						<div class="list-group list-group-flush">
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Created</div>
									<div class="col-md-9">
										{{ form.date_created }} by {{ form.user }}
									</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Received</div>
									<div class="col-md-9">{{ form.date_received }}</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Approved By</div>
									<div class="col-md-9">{{ form.approved_by }}</div>
								</div>
							</div>
						</div>

						<!-- Documents -->
						<legend class="px-3 pt-3 mb-0">
							<h5 class="">Documents</h5>
						</legend>
						<div class="list-group list-group-flush">
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Bank Statement</div>
									<div class="col-md-9">
										<template v-if="form.documents">
											<div v-for="doc in form.documents" :key="'doc_' + doc.id">
												<span class="badge bg-primary me-2">
													{{ doc.title }}
												</span>
											</div>
										</template>
										<span v-else>N/A</span>
									</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row align-items-start">
									<div class="col-md-3 fw-bold">Approval Document</div>
									<div class="col-md-9">
										<a
											v-if="form.approval_document"
											:href="form.approval_document"
											target="_blank"
											class="btn btn-outline-primary btn-sm"
										>
											View Document
										</a>
										<span v-else>N/A</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div align="center" style="margin-bottom: 1rem">
			<router-link :to="`/forms/reporting`" class="btn btn-secondary me-2">
				<i class="fas fa-arrow-left me-1"></i> Back
			</router-link>
			<button @click.prevent="printContent" class="btn btn-info ml-2">
				<i class="fas fa-print me-1"></i> Print Report
			</button>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
	data() {
		return {
			report: null,
		};
	},
	computed: {
		...mapGetters({
			form: "form_ec16d/singleForm",
		}),
	},
	methods: {
		...mapActions({
			getFormById: "form_ec16d/getFormById",
		}),

		closeTab() {
			return this.$router.back();
		},
		printContent() {
			const printContent = this.$refs.printContent.innerHTML;
			// const originalContent = document.body.innerHTML;

			const printWindow = window.open("", "_blank");

			printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Report Details</title>
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet">
            <style>
              @page { size: auto; margin: 10mm; }
              @media print {
                body { padding: 0; font-size: 12pt; }
                .card { border: none; box-shadow: none; margin: 0; }
                .card-header { 
                  background-color: #29623c !important; 
                  color: white !important;
                  -webkit-print-color-adjust: exact; 
                  print-color-adjust: exact;
                }
                .no-print, .no-print * { display: none !important; }
                a { text-decoration: none; color: inherit; }
                . { color: #198754 !important; }
                .bg-light { background-color: #f8f9fa !important; }
                .list-group-item { page-break-inside: avoid; }
              }
              .list-group-item { padding: 1rem; border-left: 0; border-right: 0; }
              .list-group-item .row { min-height: 25px; }
              .fw-bold { font-weight: 600 !important; }
              legend {
                    background-color: #ecf0f5;
                    color: rgb(1, 16, 1);
                    padding: 5px 10px;
                }
            }
            </style>
          </head>
          <body onload="window.print()">
            ${printContent}
          </body>
        </html>
      `);

			printWindow.document.close();
		},
		handleEdit() {
			// Handle edit functionality
			// console.log("Edit button clicked");
		},
	},
	mounted() {
		this.getFormById({ id: this.$route.params.formID });
	},
};
</script>
<style scoped>
legend {
	background-color: #ecf0f5;
	color: rgb(1, 16, 1);
	padding: 5px 10px;
}
.list-group-item {
	padding: 1rem;
	border-left: 0;
	border-right: 0;
}

.list-group-item .row {
	min-height: 30px;
}
</style>
